import Vue from 'vue';
import Vant from 'vant';
import dayjs from 'dayjs';
import '@ini/initComponent';
import '@ini/reset.css';
import 'vant/lib/index.css';
import App from './App';

import { createRouter } from './router';
import { createStore } from './store';
Vue.use(Vant);
Vue.prototype.$moment = dayjs;

Vue.config.productionTip = false;

// if (typeof window !== 'undefined') {
//   const vconsole = require('vconsole');
//   new vconsole();
// }

// if (process.env.NODE_ENV === 'development') {
// new vconsole();
// }

// 导出一个工厂函数，用于创建新的
// 应用程序、router 和 store 实例
export function createApp() {
  const router = createRouter();
  const store = createStore();
  Vue.mixin({
    beforeMount() {
      const { asyncData } = this.$options;
      if (asyncData) {
        asyncData({ store, router });
      }
    }
  });
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  });
  return { app, router, store };
}
